import CustomButton from "../../../../components/Button";
import DeleteGif from "../../../../assets/common/DeleteGif.gif";
import CloseIcon from "../../../../assets/closeIcon.svg";
import OneButton from "../../../../components/Button/OneButton";
// import CloseIcon from "../../assets/CloseIcon.svg";

const DeleteConfirmModale = (props: any) => {
  const { userInfo, setIsModalOpen, deleteRoleApiCall, title, isUser } = props;
  return (
    <div className="w-full px-4 py-6 sm:px-6 sm:py-8">
      <div className="flex flex-col items-center">
        <div className="flex justify-end"></div>
        <div className="mb-3 flex justify-center">
          <img src={DeleteGif} alt="" className="w-[88px] sm:w-[104px]" />
        </div>

        <div className="mb-6 max-w-[420px]">
          <p className="text-center text-base font-semibold lg:text-lg">
            {`Do you want to delete this  ${userInfo?.firstName} ${userInfo?.lastName} ${title} ?`}
          </p>

          <p className="mt-2 break-words text-center text-base font-semibold lg:text-lg">{`Seller Id: ${userInfo?.sellerId}`}</p>
        </div>

        <div className="flex w-full max-w-[420px] flex-col gap-3 sm:flex-row sm:justify-center sm:gap-6">
          <div className="w-full">
            <OneButton
              text="YES"
              onClick={() => {
                isUser
                  ? deleteRoleApiCall(userInfo?.userId)
                  : deleteRoleApiCall(userInfo);
              }}
              variant="primary"
              className="w-full"
            />
          </div>
          <div className="w-full">
            <OneButton
              text="CANCEL"
              onClick={() => {
                setIsModalOpen(false);
              }}
              variant="primary"
              className="w-full"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default DeleteConfirmModale;
